import siteType from '../configs/siteType'

const backgroundImage = {
  // en
  default_en: 'KK_Download page banner_en',
  elyza_en: 'banner_elyza_en',
  cheri_en: 'banner_cherizawa_en',
  cherizawa_en: 'banner_cherizawa_en',
  neil_en: 'banner_neil_en',
  ryan_en: 'banner_ryan_en',
  lorelynf_en: 'banner_lorelynf_en',
  james_cha_en: 'banner_james_cha_en',

  // ru
  default_ru: 'banner_np_ru',
  // 'PerunH_ru': 'banner_perunh_ru',
  // 'luckantikiller_ru': 'banner_luckantikiller_ru',
  // 'minthon19_ru': 'banner_minthon19_ru',
  // 'pokerbanda_ru': 'banner_pokerbanda_ru',
  // 'sharliz_ru': 'banner_sharliz_ru',
  // 'freedie_ru': 'banner_freedie_ru',
  // 'jetFIFA_ru': 'banner_jetFIFA_ru',
  // 'ktvsky_ru': 'banner_ktvsky_ru',

  // es
  default_es: 'banner_np_es',
  loko_es: 'banner_loko_es',
  toto_bordieri_es: 'banner_toto_es',
  jorge_es: 'banner_jorge_es',
  rigel_vlog_es: 'banner_regil_es',
  // 'cristian_es': 'banner_christian_es',
  // 'mourtha_new_es': 'banner_mourtha_new_es',
  peek_studio_es: 'banner_peek_studio_es',
  // 'joger_solari_es': 'banner_joger_solari_es',
  // 'matififa90_es': 'banner_matififa90_es',

  // regular
  regular_en: siteType.GetSiteType() == siteType.SITE_TYPE_NUTS ? 'KK_banner_en_nuts' : 'KK_banner_en',
  regular_es: 'KK_banner_es',
  regular_jp: 'KK_banner_jp',
  regular_mn: 'KK_banner_mn',
  regular_pt: 'KK_banner_pt',
  regular_da: 'KK_banner_da',
  regular_kr: siteType.GetSiteType() == siteType.SITE_TYPE_NUTS ? 'KK_banner_en_nuts' : 'KK_banner_en',
  regular_hi: siteType.GetSiteType() == siteType.SITE_TYPE_NUTS ? 'KK_banner_en_nuts' : 'KK_banner_en',
  regular_ru: siteType.GetSiteType() == siteType.SITE_TYPE_NUTS ? 'KK_banner_en_nuts' : 'KK_banner_en',
  regular_tc: siteType.GetSiteType() == siteType.SITE_TYPE_NUTS ? 'KK_banner_en_nuts' : 'KK_banner_en',
  regular_th: siteType.GetSiteType() == siteType.SITE_TYPE_NUTS ? 'KK_banner_en_nuts' : 'KK_banner_en',
  regular_tr: siteType.GetSiteType() == siteType.SITE_TYPE_NUTS ? 'KK_banner_en_nuts' : 'KK_banner_en',
  regular_vi: siteType.GetSiteType() == siteType.SITE_TYPE_NUTS ? 'KK_banner_en_nuts' : 'KK_banner_en',
  regular_pl: siteType.GetSiteType() == siteType.SITE_TYPE_NUTS ? 'KK_banner_en_nuts' : 'KK_banner_en',
  regular_fr: siteType.GetSiteType() == siteType.SITE_TYPE_NUTS ? 'KK_banner_en_nuts' : 'KK_banner_en',

  // footer
  footer_en: 'footer_en',
  footer_es: 'footer_es',
  footer_hi: 'footer_hi',
  footer_jp: 'footer_jp',
  footer_kr: 'footer_kr',
  footer_mn: 'footer_mn',
  footer_pt: 'footer_pt',
  footer_ru: 'footer_ru',
  footer_tc: 'footer_tc',
  footer_th: 'footer_th',
  footer_tr: 'footer_tr',
  footer_vi: 'footer_vi',

  // section
  section2_en: 'section2_en',
  section2_es: 'section2_es',
  section2_hi: 'section2_hi',
  section2_jp: 'section2_jp',
  section2_kr: 'section2_kr',
  section2_mn: 'section2_mn',
  section2_pt: 'section2_pt',
  section2_ru: 'section2_ru',
  section2_tc: 'section2_tc',
  section2_th: 'section2_th',
  section2_tr: 'section2_tr',
  section2_vi: 'section2_vi'
}

export function getBackgroundImage (res, country) {
  const isPc = window.innerWidth > 768 ? 'pc/' : ''
  if (res.influencer && country) {
    return {
      backgroundBanner: 'url(/static/img/register/' + isPc + (backgroundImage[`${res.influencer}_${country}`] || backgroundImage[`default_${country}`] || backgroundImage.default_en) + '.jpg)',
      backgroundSection: 'url(/static/img/register/' + (backgroundImage[`section2_${country}`] || backgroundImage.section2_en) + '.jpg)',
      backgroundFooterImage: 'url(/static/img/register/' + (backgroundImage[`footer_${country}`] || backgroundImage.footer_en) + '.jpg)'
    }
  } else if (country) {
    return {
      backgroundBanner: 'url(/static/img/register/' + isPc + (backgroundImage[`regular_${country}`] || backgroundImage.regular_en) + '.jpg?v=20231005)',
      backgroundSection: 'url(/static/img/register/' + (backgroundImage[`section2_${country}`] || backgroundImage.section2_en) + '.jpg)',
      backgroundFooterImage: 'url(/static/img/register/' + (backgroundImage[`footer_${country}`] || backgroundImage.footer_en) + '.jpg)'
    }
  } else {
    return {
      backgroundBanner: siteType.GetSiteType() == siteType.SITE_TYPE_NUTS ? ('url(/static/img/register/' + isPc + 'KK_banner_en_nuts.jpg?v=20231005)') : ('url(/static/img/register/' + isPc + 'KK_banner_en.jpg?v=20231005)'),
      backgroundSection: 'url(/static/img/register/section2_en.jpg)',
      backgroundFooterImage: 'url(/static/img/register/footer_en.jpg)'
    }
  }
}
